<template>
  <model-list-select
    :list="selects"
    v-model="companyId"
    option-value="id"
    option-text="name"
    :isDisabled="disabled"
    placeholder="Selecione uma Carteira"
  >
  </model-list-select>
</template>

<script>
import { baseApiUrl } from '@/global';
import axios from 'axios';
import ModelListSelect from 'vue-search-select/src/lib/ModelListSelect';

export default {
  name: 'SelectCompanies',
  components: { ModelListSelect },
  data() {
    return {
      companyId: 0,
      firstOption: this.first ? this.first : 'Todas',
      selects: [],
    };
  },
  props: {
    selected: {
      type: [Number, String],
    },
    first: {
      type: String,
    },
    disabled: {
      type: Boolean,
    },
  },
  methods: {
    getData() {
      axios(`${baseApiUrl}/v1/company/all?order=name`).then((res) => (this.selects = res.data));
    },
    emitChangeEvent(variable) {
      this.$emit('change', variable.target.value);
    },
  },
  watch: {
    companyId() {
      this.$emit('change', this.companyId);
    },
    selected() {
      this.companyId = this.selected;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
